/**
 * Remove unwanted characters from a cell summary. In addition to trailing and leading whitespaces,
 * zero-width characters are also removed:
 * - U+200B zero width space
 * - U+200C zero width non-joiner Unicode code point
 * - U+200D zero width joiner Unicode code point
 * - U+FEFF zero width no-break space Unicode code point
 *
 * @param  {string|undefined} summary - The most recent activity summary.
 * @returns A sanitized summary without trailing whitespaces and zero width characters.
 */
export function buildCellsDisplaySummary(summary: string | undefined) {
  // U+200B zero width space
  // U+200C zero width non-joiner Unicode code point
  // U+200D zero width joiner Unicode code point
  // U+FEFF zero width no-break space Unicode code point
  return summary && summary.replace(/ [\u200B-\u200D\uFEFF]/g, '').trim();
}
